import { useContext, useEffect, useState } from "react";
import { Redirect, useParams } from "react-router-dom";
import useErrorLogger from "../../common/hooks/useErrorLogger";
import { addExistingQuotes, createGroupAPI, getGroupAPI } from "../api/api";
import { IGroupResult } from "../interfaces/IGroupResult";
import { QuoteGroupContext } from "../providers/RootContextProvider";
import React from "react";
import {
    ClientProductTypes,
    isClientProductType
} from "../../common/interfaces/enums/ProductType";
import Loader from "../../common/components/Loader/Loader";
import ProductPage from "./ProductPage/ProductPage";
import { getMultiQuoteResultAPI } from "../api/endpoints/ApiQuotes";
import { getProductTypeAsString } from "../../common/shared/enumHelpers";

type ViewQuoteParams = {
    groupId: string;
    isFromCrm?: string;
};

const ViewQuotePage: React.FC<{}> = () => {
    const ErrorLogger = useErrorLogger();
    const { actions, selectors } = useContext(QuoteGroupContext);

    const params = useParams<ViewQuoteParams>();
    const urlGroupId = params.groupId;
    const isFromCrm = params.isFromCrm && params.isFromCrm === "true";

    const [isLoading, setIsLoading] = useState(false);

    const getQuoteGroup = async (): Promise<IGroupResult> => {
        return getGroupAPI(urlGroupId).catch(() => {
            return createGroupAPI();
        });
    };

    const handleGroup = async (res: IGroupResult): Promise<string> => {
        const activeClients = res.clients.filter((i) => i.isActive);
        const configs = res.quoteGroupCases.map((s) => s.config);

        actions.setClients(activeClients);
        actions.populateQuoteConfigs(configs);

        res.quoteGroupCases.forEach((item) => {
            if (isClientProductType(item.config.productType)) {
                actions.setProductEnabled(item.config.productType, item.isSelected);
            }
        });

        return addExistingQuotes(activeClients, res.quoteGroupCases);
    };

    const setQuoteGroup = async (groupId: string): Promise<void> => {
        actions.setGroupId(groupId);
        actions.setIsFromCrm(isFromCrm);
        actions.clearQuoteResults();
        actions.setIsLoadingQuoteResults(true);

        await getMultiQuoteResultAPI(groupId, selectors.getPaymentFrequency())
            .then((cards) => actions.setQuoteResults(cards))
            .finally(() => {
                actions.setIsLoadingQuoteResults(false);
                setIsLoading(false);
            });
    };

    useEffect(() => {
        if (!isLoading) {
            setIsLoading(true);
            getQuoteGroup()
                .then(async (groupRes) => {
                    await handleGroup(groupRes).then((groupId) => setQuoteGroup(groupId));
                })
                .catch((err) => {
                    ErrorLogger.Log(err, {
                        source: "ViewQuotePage - Get Quote Group"
                    });
                })
                .finally(() => {
                    actions.setIsLoadingQuoteResults(false);
                    setIsLoading(false);
                });
        }
    }, []);

    if (!isLoading && !selectors.isLoadingQuoteResult() && selectors.isQuoteResultValid())
        return <ProductPage />;
    return <Loader size="full-page" />;
};

export default ViewQuotePage;
